import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { AuthFormResetPassword } from "@/components/features/auth/reset-password";

import { useConfirmResetPasswordVerifyParams } from "./_hooks/use-confirm-reset-password-verify-params";
import { useGetResetPasswordVerifyParams } from "./_hooks/use-get-reset-password-verify-params";

export const AuthResetPasswordPage = () => {
	const { verifyCode, email } = useGetResetPasswordVerifyParams();

	const { canRender } = useConfirmResetPasswordVerifyParams(email, verifyCode);

	if (!canRender) return <></>;

	return (
		<PageMeta title="" url={PATHS.AUTH.RESET_PASSWORD}>
			<AuthFormResetPassword email={email} verifyCode={verifyCode} />
		</PageMeta>
	);
};
